export const KEY_SETUP = 0
export const KEY_SETUP_USER = 1
export const KEY_SETUP_COMPANY = 2
export const KEY_SETUP_SYSTEM = 3
export const KEY_SETUP_CREDENTIALS = 4
export const KEY_SETUP_SYSTEM_CONFIG = 5
export const KEY_SETUP_SYSTEM_THEME = 6
export const KEY_SETUP_SYSTEM_CUSTOM_THEME = 7
export const KEY_SETUP_CREDENTIALS_CONCLUSION = 8

export const KEY_PATH_SETUP = '/'
export const KEY_PATH_SETUP_USER = '/user'
export const KEY_PATH_SETUP_COMPANY = '/company'
export const KEY_PATH_SETUP_CREDENTIALS = '/credentials'
export const KEY_PATH_SETUP_SYSTEM = '/system'
export const KEY_PATH_SETUP_SYSTEM_CONFIG = '/system/config'
export const KEY_PATH_SETUP_SYSTEM_THEME = '/system/theme'
export const KEY_PATH_SETUP_SYSTEM_CUSTOM_THEME = '/system/custom-theme'
export const KEY_PATH_SETUP_CREDENTIALS_CONCLUSION = '/credentials/conclusion'

export const KEYS_ROUTES: Record<string, string> = {
  [KEY_SETUP]: KEY_PATH_SETUP_USER,
  [KEY_SETUP_USER]: KEY_PATH_SETUP_USER,
  [KEY_SETUP_COMPANY]: KEY_PATH_SETUP_COMPANY,
  [KEY_SETUP_SYSTEM]: KEY_PATH_SETUP_SYSTEM_CONFIG,
  [KEY_SETUP_CREDENTIALS]: KEY_PATH_SETUP_CREDENTIALS,
  [KEY_SETUP_SYSTEM_THEME]: KEY_PATH_SETUP_SYSTEM_THEME,
  [KEY_SETUP_SYSTEM_CUSTOM_THEME]: KEY_PATH_SETUP_SYSTEM_CUSTOM_THEME,
  [KEY_SETUP_CREDENTIALS_CONCLUSION]: KEY_PATH_SETUP_CREDENTIALS_CONCLUSION,
}
